module.exports = __webpack_public_path__ + "img/aggregate_transport_green.6e5fed48.svg";